<template>
  <!--   Main Content Start Here   -->
  <main>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <section class="dashboard_wraper">
      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="dashboard_card">
              <h2>Faqs</h2>
              <div class="account_form">
                <form method="" action="" @submit.prevent="submit()">
                  <div class="row">
                    <div
                      class="alert alert-success alert-dismissible"
                      v-if="status && status.success && status.success == 200"
                    >
                      <strong>Success!</strong> Action performed successfully.
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Key</label>
                        <select
                          v-model="formObj.key"
                          class="form-select select-menu"
                        >
                          <option value="min_wash_price">
                            Min. wash price
                          </option>
                          <option value="min_dry_clean_price">
                            Min. Dry clean price
                          </option>
                          <option value="min_tailoring_price">
                            Min. Tailoring price
                          </option>
                          <option value="min_wash_delivery_days">
                            Min. Wash delivery days
                          </option>
                          <option value="min_dry_clean_delivery_days">
                            Min. Dry clean delivery days
                          </option>
                          <option value="min_tailoring_delivery_days">
                            Min. Tailoring delivery days
                          </option>
                          <option value="max_wash_order_in_a_day">
                            Max. wash order in a day
                          </option>
                          <option value="max_dry_clean_order_in_a_day">
                            Max. Dry Clean order in a day
                          </option>
                          <option value="max_tailoring_order_in_a_day">
                            Max. tailoring order in a day
                          </option>
                          <option value="wash_per_lb_price">
                            Wash & Fold per Lb Price
                          </option>
                          <option value="system_service_fee">
                            System service fee
                          </option>
                          <option value="wash_premium_charge_fee">
                            Wash Premium charge fee
                          </option>
                          
                        </select>
                        <!-- <input
                          type="text"
                          name=""
                          v-model="formObj.key"
                          autofocus
                          required
                        /> -->
                        <v-errors :errors="errorFor('key')"></v-errors>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Title</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObj.title"
                          required
                        />

                        <v-errors :errors="errorFor('title')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Value</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObj.value"
                          required
                        />
                        <v-errors :errors="errorFor('value')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="order_buttons">
                      <input
                        type="submit"
                        class="button primary_button"
                        value="Save"
                      />
                    </div>
                  </div>
                  <hr />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!--   Main Content End Here   -->
</template>
<script>
import sidebarComponent from "./sidebar";
import { is422 } from "../../utils/response";
import validationErrors from "../../mixins/validationErrors";
import webSettings from "../../Apis/webSettings";

export default {
  mixins: [validationErrors],
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      status: null,
      errors: null,
      formObj: {
        id: null,
        key: null,
        title: null,
        value: null,
      },
    };
  },
  methods: {
    async submit() {
      console.log(this.formObj);
      if (!this.formObj.id) {
        webSettings
          .requestSettings("post", this.formObj)
          .then((response) => {
            console.log(response);
            if (response.status == 200 || response.status == 204) {
              this.status = { success: 200 };

              setTimeout(() => {
                this.$router.push({ name: "admin-general-settings" });
              }, 2000);
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
            if (is422(error)) {
              this.errors = error.response.data.errors;
            }
            this.status =
              error.response && error.response.status
                ? error.response.status
                : "";
          })
          .then(() => {
            this.loader = false;
          });
      } else {
        webSettings
          .requestSettings("put", this.formObj)
          .then((response) => {
            console.log(response);
            if (response.status == 200 || response.status == 204) {
              this.status = { success: 200 };

              setTimeout(() => {
                this.$router.push({ name: "admin-general-settings" });
              }, 2000);
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
            if (is422(error)) {
              this.errors = error.response.data.errors;
            }
            this.status =
              error.response && error.response.status
                ? error.response.status
                : "";
          })
          .then(() => {
            this.loader = false;
          });
      }
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.formObj = (await webSettings.getById(this.$route.params.id)).data;
    }
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/addUpdateSettings.vue